import BoxLayoutContent from "@/shared/components/layout/boxLauotContent";
import { useState } from "react";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { Grid, SelectChangeEvent } from "@mui/material";
import Content from "./content";
import SelectedRowDetail from "./selectedRowDetail";
import { ContentTitle } from "@/shared/components/layout/titleContentLayout";
import CardBoxLayout from "@/modules/user/layout/cardBoxLayout";

/**
 * CreditsInstallments
 *
 * مدیریت و نمایش خریدهای اعتباری مشتری به همراه امکان انتخاب موجودی
 * کیف پول و فیلترهای مربوطه.
 *
 * @remarks
 * - از useState برای مدیریت ردیف انتخاب‌شده و مقدار انتخابی در منوی بالای صفحه استفاده می‌کند.
 * - `ContentTitle` برای نمایش عنوان صفحه و کنترل انتخاب موجودی و فیلترها استفاده می‌شود.
 * - کامپوننت `Content` لیست خریدهای اعتباری را نمایش می‌دهد.
 *
 * @returns JSX.Element کامپوننتی که جدول خریدهای اعتباری و فیلترهای مرتبط را نمایش می‌دهد.
 */
const CreditsInstallments = () => {
  // const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [value, setValue] = useState("موجودی نقدی : 5,000,000 ریال");
  const menuOptions = [
    { value: "option1", label: "موجودی نقدی : 5,000,000 ریال" },
    { value: "option2", label: "گزینه دوم" },
    { value: "option3", label: "گزینه سوم" },
    { value: "option4", label: "گزینه چهارم" },
    { value: "option5", label: "گزینه پنجم" },
  ];

  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value);
  };
  
  return (
    <BoxLayoutContent
      titleElement={
        <ContentTitle handleChange={handleChange} icon={<CalendarMonthOutlinedIcon />} labelInput="" value={value} setValue={setValue} title="خریدهای اعتباری" options={menuOptions}/>
      }
    >
      <Grid sx={{ width: "100%" }}>
        <Content />
      </Grid>
    </BoxLayoutContent>
  );
};

export default CreditsInstallments;
